module.exports = __webpack_public_path__ + "trademark9.png?7d77f4647af22c46d5cfab8bde941b9e";


//////////////////
// WEBPACK FOOTER
// ./static/assets/trademark9.png
// module id = 500
// module chunks = 0